import React, { useState } from 'react';

function App() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCompanies = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('https://pratikmehta.com/trade3.0/api/get_companies.php');
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const result = await response.json();

      if (result.status === 'success') {
        setCompanies(result.data);
      } else {
        throw new Error('API returned error status');
      }
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Company List</h1>

      <button className="btn btn-primary mb-3" onClick={fetchCompanies}>
        Load Companies
      </button>

      {loading && <div className="spinner-border text-primary mb-3" role="status" />}

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {companies.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>Symbol</th>
                <th>Name</th>
                <th>Market</th>
                <th>Dividend Paying</th>
                <th>Dividend</th>
                <th>Frequency</th>
                <th>Yield</th>
                <th>Ex-Dividend Date</th>
                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((company) => (
                <tr key={company.id}>
                  <td>{company.symbol}</td>
                  <td>{company.name}</td>
                  <td>{company.market}</td>
                  <td>{company.dividend_paying}</td>
                  <td>{company.dividend || '-'}</td>
                  <td>{company.dividend_frequency || '-'}</td>
                  <td>{company.dividend_yield || '-'}</td>
                  <td>{company.ex_dividend_date || '-'}</td>
                  <td>{company.updated_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default App;
